module.exports = "/build/web/svg/chevron.6404a6be8f6afa3d9d61d6af453bfd1f.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/chevron.svg
// module id = 93
// module chunks = 24